import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow 
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import DenseTheme from "../../../app/theme/dense-theme";
import { dateUTCToFriendly } from "../../../utils/date.utils";
import { numberToCurrency } from "../../../utils/numbers.utils";

interface CapitalContributeItem {
  _id: string;
  date: string;
  value: number;
  name: string;
}

interface CapitalContributeTableProps {
  history: CapitalContributeItem[];
}

export default function CapitalContributeTable({ history }: CapitalContributeTableProps): JSX.Element {
  const calculateTotal = (items: CapitalContributeItem[]): number => {
    return items.reduce((previous, current) => Number(previous) + Number(current.value), 0);
  };

  const total = calculateTotal(history);

  return (
    <ThemeProvider theme={DenseTheme}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>FECHA</TableCell>
              <TableCell>VALOR</TableCell>
              <TableCell>DESC</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((item) => (
              <TableRow key={item._id}>
                <TableCell>{item._id}</TableCell>
                <TableCell>{dateUTCToFriendly(item.date)}</TableCell>
                <TableCell>$ {numberToCurrency(item.value)}</TableCell>
                <TableCell>{item.name}</TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={2} align="center">
                TOTAL
              </TableCell>
              <TableCell>$ {numberToCurrency(total)}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </ThemeProvider>
  );
} 